import styled from '@react-pdf/styled-components';

export const Container = styled.View`
  width:270px;
  height: 175px;
  padding:10px;
  border-radius: 4px;
  border: 1px solid #DADADA;
  display: flex;
  margin-top: 25px;
`;

export const FlexContainer = styled.View`
  width: 100%;
  height: 100%;
  flex: ${props => props.flex || 1};
  display: flex;
  flex-direction: ${props => (props.row ? 'row' : 'column')};
  justify-content: ${props => props.vAlign || 'start'};
  margin: ${props => props.margin || '0 0 0 0'};
`;

export const ImageProfile = styled.Image`
  width: 70px;
  height: 70px;
  border-radius: 4px;
`;

export const RatingRow = styled.View`
  display: flex;
  flex-direction: row;
  margin: 0;
`;

export const ListContainer = styled.View`
  width: 100%;
  height: 430px;
`;

export const WrapQuotes = styled.View`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  margin: ${props => props.margin || '-5px 0 0 0'};
`;

export const StarsWrapper = styled.View`
  flex-direction: row;
  justify-content: center;
`;

export const Star = styled.Image`
  height: 10px;
`;

export const RatingCount = styled.Text`
  margin: 0 6px;
  font-size: 9px;
`;
